/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleempathystrong3Inputs */



/**
* | output |
* | --- |
* | "You understand other people's emotional states well and take their feelings into account when talking and making decisions." |
*
* @param {Eisubscaleempathystrong3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleempathystrong3 = /** @type {((inputs?: Eisubscaleempathystrong3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleempathystrong3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You understand other people's emotional states well and take their feelings into account when talking and making decisions.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entiendes bien el estado emocional de los demás y sabes tener en cuenta sus sentimientos al hablar y al decidir.")
	return /** @type {LocalizedString} */ ("Ты хорошо понимаешь эмоциональное состояние других людей и умеешь учитывать их чувства при общении и принятии решений.")
});
export { eisubscaleempathystrong3 as "eiSubscaleEmpathyStrong" }